import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Tooltip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CloseOutlined } from '@mui/icons-material';
import { useTramits } from '../../../hooks/turns/useTramits';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { CustomInputText } from '../../CustomInputText';
import { Reorder } from "framer-motion";

export const UpdateModuleForm = ({ data, action }) => {

    const styles = useStyles();
    const [ errorTramit, setErrorTramit ] = useState(false);
    const [ tramitsModule, setTramitsModule ] = useState([]);
    const [ tramitsAvailables, setTramitsAvailables ] = useState([]);
    const { tramits } = useTramits(data?.sede?._id);
    const { handleSubmit } = useForm();

    useEffect(() => {
        let subscribed = true;
        if(subscribed) {
            const filters = tramits?.filter(t => !data?.tramites?.includes(t?.abreviacion)).map(obj => ({ uid: obj?.uid, nombre: obj?.nombre, abreviacion: obj?.abreviacion}));

            setTramitsAvailables(filters);
        }

        return () => {
            subscribed = false;
            setTramitsAvailables([]);
        }
    }, [tramits]);

    useEffect(() => {
        let subscribed = true;
        if(subscribed) {
            const newTramits = data?.tramites?.map(e => tramits?.find(obj => obj?.abreviacion?.includes(e))).filter(obj => obj !== undefined);

            setTramitsModule(newTramits);
        }

        return () => {
            subscribed = false;
            setTramitsModule([]);
        }
    }, [tramits]);

    const handleClickAdd = (tramit) => {
        setTramitsAvailables((prev) => prev?.filter(t => t?.uid !== tramit?.uid));
        setTramitsModule((prev) => ([ ...prev, tramit ]));
    }

    const handleClickRemove = (tramit) => {
        setTramitsModule((prev) => prev?.filter(t => t?.uid !== tramit?.uid));
        setTramitsAvailables((prev) => ([ ...prev, tramit ]));
    }

    const onSubmit = () => {
        if(tramitsModule?.length <= 0) return setErrorTramit(true);

        action(tramitsModule?.map(t => t?.abreviacion?.toLowerCase()));
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <div className={styles.formBody}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} lg={6}>
                        <CustomInputText
                            label='Nombre'
                            value={ convertirLetraMayus(data?.nombre) }
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <CustomInputText
                            label='Sede'
                            value={ convertirLetraMayus(data?.sede?.nombre) }
                            disabled
                        />
                    </Grid>
                </Grid>

                {
                    tramitsAvailables?.length > 0 && (
                        <Grid container spacing={2} marginBottom={2}>
                            <Grid item xs={ 12 }>
                                <label style={{ fontWeight: 600, fontSize: 14, paddingBottom: 10 }}>Trámites disponibles</label>
                            </Grid>
                            { tramitsAvailables?.map((tramit, index) => (
                                <Grid item key={index} xs={2}>
                                    <Tooltip title={ convertirLetraMayus(tramit?.nombre, true) }>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            className={styles.availableButton}
                                            onClick={ () => handleClickAdd(tramit) }
                                        >
                                            
                                            { tramit?.abreviacion?.toUpperCase() }
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            )) }
                        </Grid>
                    ) 
                }

                <Grid container marginBottom={ 2 } display='block'>
                    <Grid item='true' xs={12} md={12} lg={12} paddingBottom={ 2 }>
                        <label style={{ fontWeight: 600, fontSize: 14 }}>Trámites asignados</label>
                    </Grid>

                    {  
                        tramitsModule?.length <= 0 ? (
                            <>
                                <Grid item xs={ 12 } border={ errorTramit ? '1px solid #D32F2F' : '1px solid #bdbdbd' } borderRadius={1} height={100} display='flex' justifyContent='center' alignItems='center' marginY={1}>
                                        <span style={{ fontSize: 13, color: '#bdbdbd', fontWeight: 500 }}>Vacio</span>
                                </Grid>
                                { errorTramit && <span style={{ fontSize: 12, color: '#D32F2F' }}>* Debe tener al menos un trámite asociado.</span> }
                            </>
                        ) : (
                            <div>
                                <Reorder.Group 
                                    as='div' 
                                    axis="x" 
                                    values={tramitsModule} 
                                    onReorder={ setTramitsModule } 
                                    style={{ display: 'flex', overflowX: "scroll", scrollbarWidth: 'thin' }} 
                                    layoutScroll
                                >
                                    {tramitsModule.map((tramit) => (
                                        <Reorder.Item as='div' key={tramit?.uid} value={tramit}>
                                            <Tooltip title={ convertirLetraMayus(tramit?.nombre, true) } id={ tramit?.uid }>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    className={styles.successButton}
                                                    endIcon={ 
                                                        <CloseOutlined
                                                            sx={{ position: 'absolute', top: 0, right: 0, fontSize: '13px !important' }} 
                                                            onClick={ () => handleClickRemove(tramit) } 
                                                        /> 
                                                    }
                                                >
                                                    { tramit?.abreviacion?.toUpperCase() }
                                                </Button>
                                            </Tooltip>
                                        </Reorder.Item>
                                    ))}
                                </Reorder.Group>
                                
                                <span style={{ fontSize: 12 }}>Mayor prioridad.</span>
                            </div>
                        )
                    }
                </Grid>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant='outlined'
                    size='small'
                    className={styles.successButton}
                    type='submit'
                >
                    Actualizar
                </Button>
            </div>
        </form>
    )
}

const useStyles = makeStyles({
    form: {
        width: '100%',
        height: 'auto'
    },
    formBody: {
        height: '92%',
        padding: 30,
        overflowY: 'auto',
    },
    successButton: {
        background: '#00365F !important',
        color: '#fff !important',
        marginRight: '10px !important',
        marginBottom: '10px !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    },
    availableButton: {
        background: '#fff !important',
        color: '#00365F !important',
        marginRight: '10px !important',
        fontWeight: 'bold !important',
        border: '1px solid #00365F !important',
        '&:hover': {
            color: '#fff !important',
            background: '#00365F !important',
            borderColor: '#fff !important'
        }
    }
});